import { httpsCallable } from "firebase/functions";
import { functions } from "../firebaseConfig";

export const MAX_KIOSKS_PER_REQUEST = 50;
export type RegistrationResult = { count: number; kiosks: { id: string; docId: string; partnerId: string; status: "PENDING" }[] };

export function parseKioskIds(text: string) {
    const ids = text.split(/[\r\n,]+/).map(id => id.trim()).filter(Boolean);
    const invalidIds = ids.filter(id => !/^[a-zA-Z0-9_]{1,100}$/.test(id));
    const duplicates = Array.from(new Set(ids.filter((id, index) => ids.indexOf(id) !== index)));
    return { ids, invalidIds, duplicates };
}

export async function registerKiosks(partnerId: string, kioskIds: string[]): Promise<RegistrationResult> {
    const result = await httpsCallable<{ partnerId: string; kioskIds: string[] }, RegistrationResult>(functions, "adminRegisterKiosks")({ partnerId, kioskIds });
    return result.data;
}

export function registrationError(error: unknown): string {
    const value = error as { code?: string; message?: string; details?: { kioskIds?: string[] } };
    const errorIds = value?.details?.kioskIds;
    const ids = Array.isArray(errorIds) ? errorIds.join(", ") : "";
    switch (value?.message) {
        case "kiosk/already-exists": return `이미 등록된 ID가 있습니다${ids ? `: ${ids}` : ""}. 해당 ID를 제외하고 다시 시도해주세요. 이번 요청에서는 추가하지 않았습니다.`;
        case "kiosk/duplicate-input": return `중복 입력된 ID가 있습니다${ids ? `: ${ids}` : ""}. 한 번씩만 입력해주세요.`;
        case "kiosk/id-invalid": return "기기 ID는 영문·숫자·밑줄(_)로 1~100자까지 입력해주세요.";
        case "kiosk/count-invalid": return "기기 ID를 1~50개 입력해주세요.";
        case "kiosk/partner-invalid":
        case "kiosk/partner-not-found": return "파트너 정보를 확인할 수 없습니다. 목록을 새로고침한 뒤 다시 선택해주세요.";
    }
    if (value?.code === "functions/permission-denied") return "기기를 추가할 관리자 권한이 없습니다.";
    if (value?.code === "functions/unauthenticated") return "로그인이 만료되었습니다. 다시 로그인해주세요.";
    return "저장 결과를 확인하지 못했습니다. 등록 대기 목록을 확인한 뒤 다시 시도해주세요.";
}
